import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { ADMIN_URL } from './constant/BaseApiUrl';

export default class TermsAndConditionsService {
  getData(tab: string, type: string) {
    return axios.get(`${ADMIN_URL}${ApiKey.TERM_CONDITIONS}/${tab}/${type}`);
  }
  updateData(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.TERM_CONDITIONS}`, payload);
  }
  getBookingTermsAndConditions(type: string) {
    return axios.get(`${ADMIN_URL}${ApiKey.TERM_CONDITIONS}/${type}`);
  }
  saveBookingTermAndCondition(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.TERM_CONDITIONS}`, payload);
  }
}
